<div class="table-header">

    @if (canHaveColumnFilter) {

        <div class="column-filters-container">

            @if(!!column.columnFilterType) {
                <kal-icon (click)="toggleFilters()"
                          [ngClass]="{'gup-U-color--orange': isFiltered}">
                    <i class="material-icons">
                        <i class="material-icons">sort</i>
                    </i>
                </kal-icon>
            }

            @if (displayFiltersBox) {
                <div (click)="close()" class="overlay"></div>

                <kal-card [formGroup]="form"
                          class="column-filters"
                          columnFilterPosition>

                    @switch (column.columnFilterType) {
                        @case (ColumnFilterType.Text) {
                            @if(!showEmptyValuesOnly) {
                                <div class="gup-C-flexGroup__item -full">

                                    <kal-form-field>
                                        <kal-input [label]="column.label + ' contient'"
                                                   (keydown.enter)="applyFilters()"
                                                   formControlName="textFilter"></kal-input>
                                    </kal-form-field>

                                </div>
                            }
                        }

                        @case (ColumnFilterType.Date) {
                            @if(!showEmptyValuesOnly) {
                                <app-date-range [controlLabel]="column.label"
                                                (keydown.enter)="applyFilters()"
                                                formControlName="dateFilter">
                                </app-date-range>
                            }
                        }

                        @case (ColumnFilterType.Number) {
                            <div class="filter-title">{{ column.label }}</div>

                            @if(!showEmptyValuesOnly) {
                                <app-number-range [controlLabel]="column.label"
                                                  (keydown.enter)="applyFilters()"
                                                  formControlName="numberfilter"
                                                  inputType="number">
                                </app-number-range>
                            }
                        }

                        @case (ColumnFilterType.List) {
                            <div class="filter-title">{{ column.label }}</div>

                            @if (!showEmptyValuesOnly) {
                                <div [class.filter-list-container]="listFilter.length > 4">
                                    @for(control of listFilter.controls; track i; let i = $index) {
                                        <div formArrayName="listFilter">

                                            <div [formGroupName]="i" class="flexLine accordeon">

                                                <kal-checkbox [label]="control.value.label"
                                                              formControlName="selected">
                                                </kal-checkbox>

                                            </div>

                                        </div>
                                    }
                                </div>
                            }

                        }
                    }

                    <kal-form-field class="without-label gup-U-margin-top--mini">
                        <kal-checkbox label="Rechercher uniquement les valeurs vides"
                                      formControlName="showEmptyValuesOnly"/>
                    </kal-form-field>

                    <kal-card-actions>

                        <kal-button (click)="applyFilters()"
                                    kalTheme="primary">
                            Appliquer
                        </kal-button>

                        <kal-button (click)="close()"
                                    kalTheme="secondary">
                            Annuler
                        </kal-button>

                        <kal-button (click)="resetFilters()"
                                    kalTheme="tertiary">
                            Réinitialiser
                        </kal-button>

                    </kal-card-actions>

                </kal-card>
            }
        </div>

    }
    <div (click)="sortByColumn()" [title]="column.label" class="table-header-label">
        <div>{{ column.label }}</div>
    </div>

</div>

<span class="resizer"
      cdkDrag
      cdkDragLockAxis="x"
      [cdkDragFreeDragPosition]="headerDragPosition"
      (cdkDragMoved)="onResize($event)"
      (cdkDragEnded)="onResizeEnd()">
</span>
